<template>
    <div class="animated fadeIn kgr-row kgr-row--bigMargin">
        <h2
            v-if="null !== heading || null !== note"
            class="kgr-headline kgr-headline--h3 kgr-headline--text kgr-headline--firstInText"
        >
            <template v-if="null !== heading">
                {{ heading }}
            </template>
            <span
                v-if="null !== note"
                class="note"
            >{{ note }}</span>
        </h2>
        <slot
            class="part-heading"
            name="heading"
        ></slot>

        <div class="part-content">
            <slot name="content"></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        heading: {
            type: String,
            required: false,
            default: null,
        },
        note: {
            type: String,
            required: false,
            default: null,
        },
    },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    .part-container {
    margin-bottom: 30px;
}

.part-content table {
    line-height: 18px;
}

.part-content tr > td:first-child {
    padding-right: 10px;
}

.part-content tr {
    vertical-align: top;
}
</style>
